import { Link, styled } from "@mui/material";

const LinkElementStyled = styled(Link)({
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "16px",
    textDecorationLine: "underline",
    color: "#42AEE7",
});

export default LinkElementStyled;
